'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { toast } from '@/lib/toast'
import {
  saveAddressApi,
  updateAddressApi,
  setDefaultAddressApi,
  deleteAddressApi,
} from '@/lib/commerce/services/address-api'

export function useAddressManagement() {
  const router = useRouter()
  const [submitting, setSubmitting] = useState(false)
  const [defaultingId, setDefaultingId] = useState<string | null>(null)
  const [deletingId, setDeletingId] = useState<string | null>(null)

  const [openAdd, setOpenAdd] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [addressToEdit, setAddressToEdit] = useState<any>(null)

  const addAddress = async (body: any): Promise<boolean> => {
    setSubmitting(true)
    const res = await saveAddressApi(body)
    setSubmitting(false)
    if (!res || res.error || !res.data) {
      toast.error(res?.error || 'Хаяг нэмэхэд алдаа гарлаа')
      return false
    }
    toast.success('Хаягийн мэдээллийг амжилттай нэмлээ')
    router.refresh()
    return true
  }

  const updateAddress = async (id: string, body: any): Promise<boolean> => {
    setSubmitting(true)
    const res = await updateAddressApi(id, body)
    setSubmitting(false)
    if (!res || res.error || !res.data) {
      toast.error(res?.error || 'Хаяг засахад алдаа гарлаа')
      return false
    }
    toast.success('Хаяг амжилттай засагдлаа')
    router.refresh()
    return true
  }

  const setDefault = async (id: string) => {
    setDefaultingId(id)
    const res = await setDefaultAddressApi(id)
    setDefaultingId(null)
    if (!res || res.error || !res.data) return toast.error(res?.error || 'Үндсэн хаяг болгоход алдаа гарлаа')
    toast.success('Үндсэн хаягийг амжилттай тохирууллаа')
    router.refresh()
  }

  const removeAddress = async (id: string) => {
    setDeletingId(id)
    const res = await deleteAddressApi(id)
    setDeletingId(null)
    if (!res || res.error || !res.data) return toast.error(res?.error || 'Хаяг устгахад алдаа гарлаа')
    toast.success('Хаягийн мэдээллийг амжилттай устгалаа')
    router.refresh()
  }

  const startEdit = (address: any) => {
    setAddressToEdit(address)
    setOpenEdit(true)
  }

  return {
    submitting,
    defaultingId, deletingId,
    openAdd, setOpenAdd,
    openEdit, setOpenEdit,
    addressToEdit,
    addAddress, updateAddress,
    setDefault, removeAddress,
    startEdit,
  }
}
